import { render, staticRenderFns } from "./flowplus.vue?vue&type=template&id=12372bae&scoped=true&lang=pug&"
import script from "./flowplus.vue?vue&type=script&lang=js&"
export * from "./flowplus.vue?vue&type=script&lang=js&"
import style0 from "./flowplus.vue?vue&type=style&index=0&id=12372bae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12372bae",
  null
  
)

export default component.exports